import { type DetailsReturn } from '@shared/all/domains/user';
import { useQueryClient } from '@tanstack/react-query';

import { userActions } from '../context/context';
import { useUserState } from '../context/UserContext';

const useUser = () => {
  const { state, dispatch } = useUserState();
  const queryClient = useQueryClient();

  const setIsAuthenticated = (isAuthenticated: boolean) => {
    dispatch({
      type: userActions.SET_IS_AUTHENTICATED,
      payload: isAuthenticated
    });
  };

  const setUser = (user: DetailsReturn) => {
    dispatch({ type: userActions.SET_USER, payload: user });
  };

  const addTrons = (trons: number) => {
    dispatch({ type: userActions.ADD_TRONS, payload: trons });
  };

  const setPendingNotificationsCount = (count: number) => {
    queryClient.setQueryData(['notifications', 'unreadCount'], count);
  };

  return {
    currentUser: state.user,
    setIsAuthenticated,
    setUser,
    addTrons,
    setPendingNotificationsCount
  };
};

export default useUser;
